/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.5 11.25V9c0-.0005 0 .0005 0 0-.0008-.4136-.3363-.75-.75-.75a.7502.7502 0 0 0-.738.6152L0 9v6c0 .0005 0-.0005 0 0 .0008.4135.3363.75.75.75a.7502.7502 0 0 0 .738-.6152L1.5 15v-2.25h19.6287l-7.6722 7.6722-.0475.0474c-.0003.0004.0003-.0003 0 0a.7518.7518 0 0 0-.0868.9568l.0868.1039a.7502.7502 0 0 0 .9568.0868l.1039-.0868L24 12l-9.5303-9.5304c-.0004-.0003.0003.0004 0 0-.293-.2918-.7681-.2925-1.0607 0a.7503.7503 0 0 0-.0868.9568l.0868.104c.0002.0001-.0002-.0003 0 0l7.7198 7.7196H1.5Z"
    clipRule="evenodd"
  />,
  'Promote'
);
